import React, { useState } from 'react'
import { Modal, Container, Spinner, Alert } from 'react-bootstrap'
import { useSelector, useDispatch, connect } from 'react-redux'
import {
    ResetStatusContactConsultant,
} from 'application/actions/contactUsActions'
import { submitContactConsultantDetails } from 'application/actions/contactUsActions'
import {
  addHoursToCurrentDate,
  fireInteractionCustomEvent,
} from 'application/helpers'
import { PrimaryButton } from '@mmsg/louie'
import * as E from './contactUsDialogElements'
import { Icon as MaxxiaIcon } from 'Maxxia/icons'
import { Icon as RemServIcon } from 'RemServ/icons'

const ContactUsDialog = (props) => {
  let isFormSubmitted = useSelector(
    (state) => state.contactUs && state.contactUs.isSubmitted
  )
  let isSubmissionInProgress = useSelector(
    (state) => state.contactUs && state.contactUs.isLoading
  )
  let hasSubmissionFailed = useSelector(
    (state) => state.contactUs && state.contactUs.hasSubmissionFailed
  )
  const [showDialog, setShowDialog] = useState(false)
  const [preferredDateTIme, setPreferredDateTime] = useState(
    addHoursToCurrentDate(25)
  )
  const [dialogLength, setDialogLength] = useState(0)
  const [modeOfContact, setModeOfContact] = useState('')
  
  const OnShowDialog = () => {
    setShowDialog(true)
  }
  
  const OnHideDialog = () => {
    setModeOfContact('')
    setShowDialog(false)
    dispatch(ResetStatusContactConsultant())
  }  

  let opportunityId = useSelector(
    (state) => state.authentication && state.authentication.opportunityId
  )

  const OnModeOfContactChanged = (e) => {
    setModeOfContact(e.target.value)
    ValidateModeOfContact(e.target.value)
  }

  let formFields = {
    isQuestionTxtValid: false,
    isModeOfContactValid: false,
    isPreferredTimeValid: false,
  }

  let isValidDate = (date) => {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
      ? true
      : false
  }

  let ValidatePreferredDateTime = () => {
    let isValid = false
    if (modeOfContact === 'Email') {
      formFields.isPreferredTimeValid = true
      isValid = true
      return
    } else {
      if (isValidDate(document.getElementById('txtPreferredTime').value)) {
        isValid = true
      } else {
        isValid = false
      }
    }

    if (isValid) {
      let todaysDate = new Date()
      // seconds * minutes * hours * milliseconds = 1 day
      let day = 60 * 60 * 24 * 1000
      if (
        new Date(document.getElementById('txtPreferredTime').value) <
        new Date(todaysDate.getTime() + day)
      ) {
        document.getElementById('errorMsg-txtPreferredTime').style.display =
          'block'
        formFields.isPreferredTimeValid = false
      } else {
        document.getElementById('errorMsg-txtPreferredTime').style.display =
          'none'
        formFields.isPreferredTimeValid = true
      }
    } else {
      document.getElementById('errorMsg-txtPreferredTime').style.display =
        'block'
      formFields.isPreferredTimeValid = false
    }
  }

  let ValidateModeOfContact = (mode) => {
    let isChecked
    if(mode)
      isChecked = (mode !== "")
    else
      isChecked = (modeOfContact !== '')

    if (!isChecked) {
      document.getElementById('errorMsg-modeOfContact').style.display = 'block'
      formFields.isModeOfContactValid = false
    } else {
      document.getElementById('errorMsg-modeOfContact').style.display = 'none'
      formFields.isModeOfContactValid = true
    }

    return isChecked
  }

  const OnSubmitContactConsultant = () => {
    let isFormDataValid = false
    if (ValidateModeOfContact()) {
      ValidatePreferredDateTime()
    }
    ValidateTxtQuestion()

    if (
      formFields.isQuestionTxtValid &&
      formFields.isModeOfContactValid &&
      formFields.isPreferredTimeValid
    ) {
      isFormDataValid = true
    }

    if (isFormDataValid) {
      // Make service call for submission
      let queryDetails = {
        message: encodeURI(document.getElementById('txtQuestion').value),
        preferredMethod: modeOfContact,
        preferredTime:
          modeOfContact === 'Phone'
            ? document.getElementById('txtPreferredTime').value
            : new Date(),
      }

      dispatch(submitContactConsultantDetails(opportunityId, queryDetails))
      fireInteractionCustomEvent({
        detail: {
          eventType: 'custom link click',
          data: {
            category: 'button',
            section: 'mylease',
            text: 'contact consultant',
            label: 'contact consultant',
          },
        },
      })
    }
  }

  const ValidateTxtQuestion = () => {
    setDialogLength(document.getElementById('txtQuestion').value.length)
    if (document.getElementById('txtQuestion').value === '') {
      document.getElementById('errorMsg-txtQuestion').style.display = 'block'
      formFields.isQuestionTxtValid = false
    } else {
      document.getElementById('errorMsg-txtQuestion').style.display = 'none'
      formFields.isQuestionTxtValid = true
    }
  }

  const dispatch = useDispatch()
  
  let consultant = useSelector((state) => state.consultant)
  return (
    <E.MainSpan>
      {props.theme && props.theme === 'link' && (
        <button
          className={`${props.className} clickable`}
          onClick={OnShowDialog}
          id={props.id}
          style={{ border: 'none', background: 'none' }}
        >
          {props.launchText}
        </button>
      )}
      {props.theme && props.theme !== 'link' && (
        <PrimaryButton
          variant={props.variant}
          size={props.size}
          className={props.className}
          onClick={OnShowDialog}
          extendInMob={props.extendInMob}
          invertColor={props.invertColor}
          id={props.id} //TODO id in Louie
        >
          {props.launchText}
        </PrimaryButton>
      )}
      <E.StyledModal show={showDialog} onHide={OnHideDialog}>
        <Modal.Header closeButton>
          <Modal.Title className="text-uppercase width-100perc">
            <div className="text-center width-100perc">
              {!isFormSubmitted && (
                <h1 className="text-left">Contact your consultant</h1>
              )}
              {isFormSubmitted && (
                <div className="icon-header-section text-center pd-40">
                  {global.config.isBrandMX && (
                    <MaxxiaIcon iconType="Phone" />
                  )}
                  {global.config.isBrandRS && (
                    <RemServIcon iconType="phone" />
                  )}
                </div>
              )}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {isFormSubmitted && (
              <Container>
                <div className="font-weight-bold mb-2">
                  Contact request sent!
                </div>
                <div className="mb-2">
                  We’ve let {consultant.firstName} know you’d like them to get
                  in touch. You can expect to hear from them shortly.
                </div>
                <div className="mb-2">
                  In the meantime, you’ll receive a confirmation email in your
                  inbox.
                </div>
                <div className="d-flex justify-content-end  mb-2 mt-3">
                  <PrimaryButton extendInMob size="sm" onClick={OnHideDialog}>
                    Got it
                  </PrimaryButton>
                </div>
              </Container>
            )}
            {!isFormSubmitted && (
              <form>
                <div className="font-weight-bold mb-2">
                  Your consultant's contact details
                </div>
                <div className="mb-3">
                  <E.HeadingDiv>Consultant name</E.HeadingDiv>
                  <E.ValueDiv>
                    {consultant.firstName} {consultant.lastName}
                  </E.ValueDiv>
                </div>

                {consultant.email && (
                  <div className="mb-3">
                    <E.HeadingDiv>Email</E.HeadingDiv>
                    <E.ValueDiv>
                      <a href={`mailto:${consultant.email}`}>
                        {consultant.email}
                      </a>
                    </E.ValueDiv>
                  </div>
                )}

                {consultant.telephone && (
                  <div className="mb-4">
                    <div>Phone number</div>
                    <div className="font-weight-bold text-underline">
                      {consultant.telephone}
                    </div>
                  </div>
                )}

                <div className="font-weight-bold mb-1">
                  How would you like {consultant.firstName} to contact you?
                </div>

                <div className="mb-1">
                  Your consultant will contact you using the details we have on
                  file.
                </div>
                {global.config.isBrandRS && (
                  <>
                    <div>(All fields are mandatory)</div>
                    <br />
                  </>
                )}
                <div className="mb-3">
                  <div className="mandatory">
                    Select your preferred contact method
                  </div>
                  <div>
                    <span className="mr-3">
                      <input
                        type="radio"
                        value="Phone"
                        name="modeOfContact"
                        onChange={OnModeOfContactChanged}
                        id="modeOfContact.phone"
                      />{' '}
                      <label for="modeOfContact.phone">Phone</label>
                    </span>
                    {global.config.isBrandRS && <br />}
                    <input
                      type="radio"
                      value="Email"
                      name="modeOfContact"
                      onChange={OnModeOfContactChanged}
                      id="modeOfContact.email"
                    />{' '}
                    <label for="modeOfContact.email">Email</label>
                  </div>
                  <div id="errorMsg-modeOfContact" className="errorMsg">
                    Please select your preferred contact method
                  </div>
                </div>
                <div className="mb-3">
                  <span className="mandatory">
                    What question would you like answered.
                  </span>
                  <E.TextAreaLength>
                    {dialogLength >= 150 && (
                      <E.WarningIcon
                        src="/images/icon-warningtriangle.svg"
                        alt=""
                      />
                    )}
                    {dialogLength}/200
                  </E.TextAreaLength>
                  <E.StyledTextArea
                    id="txtQuestion"
                    onChange={ValidateTxtQuestion}
                    maxLength="200"
                    placeholder={
                      global.config.isBrandRS &&
                      'e.g. Can I add tinting to the car window?'
                    }
                  ></E.StyledTextArea>
                  <div id="errorMsg-txtQuestion" className="errorMsg">
                    Please outline your question in 200 characters or less.{' '}
                  </div>
                </div>
                { modeOfContact === 'Phone' && (
                    <div className="mb-3">
                      <div className="mandatory">
                        What day and time works best for you.
                      </div>
                      {global.config.isBrandMX && (
                        <p className="text-small">
                          (Must be more than 24hrs from now)
                        </p>
                      )}
                      <input
                        type="datetime-local"
                        id="txtPreferredTime"
                        onChange={() => {
                          setPreferredDateTime(
                            document.getElementById('txtPreferredTime').value
                          )
                          ValidatePreferredDateTime()
                        }}
                        value={preferredDateTIme}
                      />
                      {global.config.isBrandRS && (
                        <p className="text-smaller mt-1">
                          Note: Must be more than 24 hours from how.
                        </p>
                      )}
                      <div id="errorMsg-txtPreferredTime" className="errorMsg">
                        Please select a date more than 24hrs from now.
                      </div>
                    </div>
                  )}
                {hasSubmissionFailed && (
                  <div className="mt-2 mb-2">
                    <Alert variant="danger">
                      Error submitting your request. Please try again
                    </Alert>
                  </div>
                )}
                <div>
                  {isSubmissionInProgress && (
                    <PrimaryButton className="mr-3 mb-3" size="sm">
                      <>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="mb-1"
                        />
                        Sending...
                      </>
                    </PrimaryButton>
                  )}
                  {!isSubmissionInProgress && (
                    <PrimaryButton
                      onClick={OnSubmitContactConsultant}
                      className="mr-3 mb-3"
                      extendInMob
                      size="sm"
                    >
                      Send message
                    </PrimaryButton>
                  )}
                  <PrimaryButton
                    variant={'invertColor'}
                    className="mb-3"
                    invertColor
                    extendInMob
                    onClick={OnHideDialog}
                    size="sm"
                    id="contactusdialog.close"
                  >
                    Close
                  </PrimaryButton>
                </div>
              </form>
            )}
          </div>
        </Modal.Body>
      </E.StyledModal>
    </E.MainSpan>
  )
}

function mapStateToProps(state) {
  return {
    contactUs: state.contactUs,
  }
}

export default connect(mapStateToProps)(ContactUsDialog)
